<template>
	<div>
		<form-sidebar>
			<v-form>
				<v-layout wrap>
					<v-flex xs12>
						<label class="title-section">Datos de la Compañía</label>
					</v-flex>
					<v-flex xs12 pt-0 mb-3>
						<v-divider></v-divider>
					</v-flex>
				</v-layout>
				<v-layout row wrap px-2>
					<v-flex xs12 md6 mb-4>
						<BaseSelect
							label="Tipo de Documento"
							item-text="name"
							item-value="id"
							:height="38"
							:items="documents"
							v-model="$v.model.flagTypePerson.$model"
						/>
						<span class="error--text caption" v-if="$v.model.flagTypePerson.$invalid">
							El tipo de documento es requerido
						</span>
					</v-flex>
					<v-flex xs12 md6 mb-4>
						<BaseInput
							:height="38"
							label="Nro de Documento"
							type="number"
							v-model="$v.model.ruc.$model"
						/>
						<span class="error--text caption" v-if="!$v.model.ruc.required">
							El número de documento es requerido
						</span>
						<span class="error--text caption" v-if="!$v.model.ruc.maxLength">
							El ruc solo puede tener 13 digitos
						</span>
					</v-flex>
					<v-flex xs12 md6 mb-4>
						<BaseInput
							:height="38"
							:label="nameLabel"
							v-model="$v.model.name.$model"
						/>
						<span class="error--text caption" v-if="$v.model.name.$invalid">
							El nombre es requerido
						</span>
					</v-flex>
					<v-flex xs12 md6 mb-4 v-if="!isLegal">
						<BaseInput
							:height="38"
							label="Apellido"
							v-model="$v.model.lastname.$model"
						/>
						<span class="error--text caption" v-if="$v.model.lastname.$invalid">
							El apellido es requerido
						</span>
					</v-flex>
					<v-flex xs12 md6 mb-4 v-else>
						<BaseInput
							:height="38"
							label="Razón Social"
							v-model="$v.model.rzSocial.$model"
						/>
						<span class="error--text caption" v-if="$v.model.rzSocial.$invalid">
							La razón social es requerida
						</span>
					</v-flex>
					<v-flex xs12 md6 mb-4>
						<BaseInput
							:height="38"
							label="Dirección"
							v-model="$v.model.address.$model"
						/>
						<span class="error--text caption" v-if="$v.model.address.$invalid">
							La dirección es requerida
						</span>
					</v-flex>
					<v-flex xs12 md6 mb-4>
						<BaseInput
							type="number"
							:height="38"
							label="Teléfono"
							v-model="model.phone"
						/>
					</v-flex>
					<v-flex xs12 md6>
						<BaseDate
							type="date"
							:height="38"
							label="Fecha de Inicio"
							v-model="model.startDateFunctions"
						/>
						<span class="error--text caption" v-if="$v.model.startDateFunctions.$invalid">
							La fecha de inicio es requerida
						</span>
					</v-flex>
					<v-flex xs12 md6 pr-2 class="no-error-message">
						<BaseSelect
							label="Género"
							item-text="name"
							item-value="id"
							:height="38"
							:items="gender"
							v-model="model.gender"
						/>
					</v-flex>
					<v-flex xs12 md6 pl-2 class="no-error-message">
						<BaseSelect
							label="Estado Civil"
							item-text="name"
							item-value="id"
							:height="38"
							:items="civilStatus"
							v-model="model.civilStatus"
						/>
					</v-flex>
					<v-flex xs12 md6>
						<BaseSelect
							readonly
							label="País"
							item-text="name"
							item-value="id"
							:height="38"
							:items="countries"
							v-model="$v.model.countryId.$model"
						/>
						<span class="error--text caption" v-if="$v.model.countryId.$invalid">
							El país es requerido
						</span>
					</v-flex>
					<v-flex xs12 md6>
						<label ref="label" for="company-logo">
							<vue-six-four
								id="company-logo"
								hidden
								@vue-six-four="getFile"
							/>
							<v-layout wrap justify-center>
								<v-flex xs10>
									<BaseInput
										:height=38
										label="Logo de la Compañía"
										readonly
										v-model="companyLogo"
									>
									<span slot="error" class="caption error--text" v-if="!$v.companyLogo.required">
										El logo es requerido
									</span>
									</BaseInput>
								</v-flex>
								<v-flex xs2>
									<v-btn
										@click="showDialog"
										class="btn-auto"
										color="info"
										text-xs-center>
										<v-icon color="white">image</v-icon>
									</v-btn>
								</v-flex>
							</v-layout>
						</label>
					</v-flex>
				</v-layout>
				<v-layout wrap>
					<v-flex xs12 pb-0 pt-4>
						<label class="title-section">Credencial del Cliente</label>
					</v-flex>
					<v-flex xs12 pt-0 pb-3>
						<v-divider></v-divider>
					</v-flex>
				</v-layout>
				<v-layout wrap mb-4>
					<v-flex xs12 md6>
						<v-layout wrap>
							<v-flex xs12>
								<BaseInput
									type="email"
									:height="38"
									label="Correo"
									v-model="$v.model.email.$model"
								/>
								<span class="error--text caption" v-if="!$v.model.email.required">
									El correo es requerido
								</span>
								<span class="error--text caption" v-else-if="!$v.model.email.email">
									Debe ingresar un correo válido. Ejemplo: micuenta@mail.com
								</span>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 md6 v-if="!customerId">
						<v-layout wrap>
							<v-flex xs12>
								<BaseInput
									type="password"
									:height="38"
									label="Contraseña"
									v-model="$v.model.password.$model"
								/>
								<span class="error--text caption" v-if="$v.model.password.$invalid">
									La contraseña es requerida
								</span>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						@cancel-button-clicked="closeModal"
						@accept-button-clicked="submitForm"
						:is-loading="$v.$invalid"
					>
					</modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import VueSixFour from 'vue-six-four';
import { email, required, requiredIf, maxLength } from 'vuelidate/lib/validators';
import appDateMask from '@/components/shared/app-date-mask';
import helper from '@/shared/helper';

const { exactDate } = helper;

const PAGE_CUSTOMER_LIST = 'customers';

function created() {
	this.loadResources();
}

function closeModal() {
	this.goTo(PAGE_CUSTOMER_LIST);
}

function isLegal() {
	const documentSelected = this.documents.find(d => d.id === this.model.flagTypePerson) || {};
	return documentSelected.name === 'RUC';
}

async function loadData() {
	const { data: record } = await this.$http.get(`customer/${this.customerId}`);
	if (record) {
		this.model = {
			address: record.address,
			civilStatus: record.civilStatus,
			countryId: record.countryId,
			email: record.email,
			flagTypePerson: record.flagTypePerson,
			gender: record.gender,
			name: record.name,
			lastname: record.lastname,
			phone: record.phone,
			ruc: record.ruc,
			rzSocial: record.rzSocial,
			startDateFunctions: exactDate(record.startDateFunctions, 'YYYY-MM-DD'),
		};
		this.companyLogo = record.additionalInformation.logo;
	}
}

async function loadResources() {
	const request = [
		this.$http.get('type-person'),
		this.$http.get('countries'),
		this.$http.get('company-token'),
	];
	[{ data: this.documents }, { data: this.countries }, { data: this.infoUser }]
		= await Promise.all(request);
	this.model.countryId = this.infoUser.company.countryCode === 'ECU' ? this.countries[0].id : this.countries[1].id;
	if (this.documents.length === 1) {
		this.model.flagTypePerson = this.documents[0].id;
	}
	if (this.mode === 'edit') {
		this.loadData();
	}
}

function mode() {
	return this.customerId ? 'edit' : 'create';
}

function nameLabel() {
	if (this.isLegal) {
		this.model.lastname = '';
	}
	return this.isLegal ? 'Nombre Comercial' : 'Nombre';
}

function onDate(value, modelName) {
	this.model[modelName] = value;
}

async function submitForm() {
	const method = this.mode === 'create' ? 'post' : 'patch';
	const url = this.mode === 'create' ? 'customer' : `customer/${this.customerId}`;
	const body = this.buildBody(this.model);
	try {
		await this.$http[method](url, body);
		this.showNotification('La compañía ha sido registrada correctamente.');
		this.goTo(PAGE_CUSTOMER_LIST);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			if (err.data.message === 'EMAIL_COMPANY_DUPLICATE') {
				this.showGenericError('El correo ya se encuentra registrado.');
			} else if (err.data.message === 'CODE_COMPANY_DUPLICATE') {
				this.showGenericError('El número de documento ya se encuentra registrado.');
			} else if (err.data.message === 'CUSTOMER_EXIST_ERROR') {
				this.showGenericError('LA compañía ya se encuentra registrada.');
			}
		}
	}
}

function buildBody(model) {
	const newModel = { ...model };
	newModel.startDateFunctions = helper.formatDate(model.startDateFunctions, 'YYYY-MM-DD');
	return newModel;
}

function showDialog() {
	this.$refs.label.click();
}

async function getFile(fileInfo) {
	this.companyLogo = fileInfo.name.replace(/\s/g, '-');
	const newFile = {
		name: fileInfo.name.replace(/\s/g, '-'),
		base64data: fileInfo.sixFour,
	};
	try {
		const words = newFile.name.split('.');
		const lastItem = words.length;
		const extension = words[lastItem - 1];
		if (this.allowedFiles.indexOf(extension) > -1) {
			const { data: file } = await this.$httpProduction.post('upload-files-public', newFile);
			this.companyLogo = file.Location;
			this.model.additionalInformation = { logo: file.Location };
		} else {
			this.showNotification(`Archivo no válido, solo se permite ${this.allowedFiles.join(',')}`, 'warning');
		}
	} catch (error) {
		this.showGenericError();
	}
}

function validations() {
	const validation = {
		model: {
			address: {
				required,
			},
			countryId: {
				required,
			},
			email: {
				email,
				required,
			},
			flagTypePerson: {
				required,
			},
			lastname: {
				required: requiredIf(() => !this.isLegal),
			},
			name: {
				required,
			},
			password: {
				required: requiredIf(() => !this.customerId),
			},
			ruc: {
				required,
				maxLength: maxLength(13),

			},
			rzSocial: {
				required: requiredIf(() => this.isLegal),
			},
			startDateFunctions: {
				required,
			},
		},
		companyLogo: {
			required,
		},
	};
	return validation;
}

function data() {
	return {
		civilStatus: [
			{ id: 1, name: 'Soltero' },
			{ id: 2, name: 'Casado' },
			{ id: 3, name: 'Viudo' },
			{ id: 4, name: 'Divorciado' },
		],
		countries: [],
		documents: [],
		gender: [
			{ id: 1, name: 'Masculino' },
			{ id: 2, name: 'Femenino' },
		],
		model: {
			address: '',
			civilStatus: null,
			countryId: null,
			email: '',
			flagTypePerson: null,
			gender: null,
			name: '',
			lastname: '',
			password: '',
			phone: '',
			ruc: null,
			rzSocial: '',
			startDateFunctions: null,
			additionalInformation: {
				logo: '',
			},
		},
		valueStartDate: null,
		infoUser: {},
		companyLogo: null,
		allowedFiles: ['jpeg', 'png'],
	};
}

export default {
	name: 'customer-form',
	components: {
		appDateMask,
		BaseDate: () => import('@/components/shared/inputs/base-date'),
		BaseInput: () => import('@/components/shared/inputs/base-input'),
		BaseSelect: () => import('@/components/shared/inputs/base-select'),
		VueSixFour,
	},
	computed: {
		isLegal,
		mode,
		nameLabel,
	},
	created,
	data,
	methods: {
		buildBody,
		closeModal,
		loadData,
		loadResources,
		onDate,
		submitForm,
		showDialog,
		getFile,
	},
	props: {
		customerId: {
			type: [Number, String],
		},
	},
	validations,
};
</script>

<style lang="scss" scoped>
	.title-section {
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small13);
		padding-left: 9px;
		text-transform: uppercase;
	}

	hr {
		border-color: map-get($colors, grey-divider) !important;
		border-width: 1.5px;
	}

	.column-left {
		padding-right: 40px !important;
		
		@media (max-width: 900px) {
			padding-right: 8px !important;
		}
	}

	.column-right {
		padding-left: 40px !important;
		
		@media (max-width: 900px) {
			padding-left: 8px !important;
		}
	}

	.no-error-message {
		height: 78px;
	}
</style>



// WEBPACK FOOTER //
// src/components/customers/customer-form.vue